import React, { useCallback, useEffect, useRef, useState } from 'react';
import QrScanner from 'qr-scanner';
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

function QrReader({ onResult, open, onClose }) {
    const [noCamera, setNoCamera] = useState(false);
    let scanner = useRef();

    const container = useCallback(element => {
        if (element == null) return;

        scanner.current = new QrScanner(element, handleScan, {});
        scanner.current.start();
    }, []); // eslint-disable-line

    const handleClose = () => {
        scanner.current.stop();
        scanner.current.destroy();
        onClose();
    }

    const handleScan = (data) => {
        handleClose();
        onResult(data);
    }

    useEffect(() => {
        const checkNoCamera = async () => {
            let hasCamera = await QrScanner.hasCamera();
            setNoCamera(!hasCamera);
        };

        checkNoCamera();
    });

    if (noCamera) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography variant="body2" color="text.secondary">
                    The browser was unable to find a camera.
                </Typography>
            </Box>
        );
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ pb: 1 }}>Scan Ticket QR Code</DialogTitle>
            <DialogContent>
                <Box sx={{ borderRadius: 1, overflow: "hidden", border: "1px solid rgba(19, 33, 68, 0.12)" }}>
                    <video width="100%" ref={container} />
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default QrReader;